import React from "react";
import "./gauge.css";

export default function Gauge({
    value = 76.32,
    label = "Solar",
    status = "Average",
    icon = '☀️',
    latString = "%"

}) {
    const size = 172;
    const strokeWidth = 18;
    let numericValue = 0;
    if (typeof value === "string" && value.includes("/")) {
        const [num, den] = value.split("/");
        if (parseFloat(den)) {
            numericValue = (parseFloat(num) / parseFloat(den)) * 100;
        }
    } else {
        numericValue = parseFloat(value) || 0;
    }

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const progress = circumference - (numericValue / 100) * circumference;

    const uniqueId = label.replace(/\s+/g, '-');

    // The strokeLinecap="round" bleeds backward by ~1.5% of the circle.
    // If the gauge isn't full, we paint the end of the 360 gradient Red so the backward bleed is Red instead of Green.
    const endColor = numericValue < 95 ? '#ef4444' : '#22c55e';
    const conicGradientString = `conic-gradient(from 0deg, #ef4444 0%, #ef4444 25%, #facc15 42%, #facc15 60%, #22c55e 80%, #22c55e 95%, ${endColor} 95.1%, ${endColor} 100%)`;

    return (
        <div className="solar-card">
            <div className="gauge-wrap">
                <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ overflow: 'visible' }}>
                    <defs>
                        <mask id={`gaugeMask-${uniqueId}`}>
                            <circle
                                className="gauge-progress"
                                cx={size / 2}
                                cy={size / 2}
                                r={radius}
                                fill="none"
                                stroke="white"
                                strokeWidth={strokeWidth}
                                strokeDasharray={circumference}
                                strokeDashoffset={progress}
                                strokeLinecap="round"
                                transform={`rotate(-90 ${size / 2} ${size / 2})`}
                            />
                        </mask>
                    </defs>

                    <circle
                        className="gauge-track"
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke="#e9eef5"
                        strokeWidth={strokeWidth}
                    />

                    <foreignObject
                        x="0" y="0" width={size} height={size}
                        mask={`url(#gaugeMask-${uniqueId})`}
                    >
                        <div style={{
                            width: '100%', height: '100%',
                            background: conicGradientString,
                            borderRadius: '50%'
                        }} />
                    </foreignObject>
                </svg>

                <div className="gauge-center">
                    <div className="solar-icon">{icon}</div>
                    <div className="percent">{value}{latString}</div>
                    <div className="status">{status}</div>
                </div>
            </div>

            <div className="label">{label}</div>
        </div>
    );
}